export const ClaimTypeList = [
  {
    text: "Outpatient",
    value: "OP",
  },
  {
    text: "Inpatient",
    value: "IP",
  },
  {
    text: "Professional",
    value: "P",
  },
];

export const CaseSummaryPage = "CSP";

export const reportBuildertTabList = [
  {
    name: "Report Body",
    code: 0,
  },
  {
    name: "Case Summary Body",
    code: 1,
  },
];

export const EntityProfileTabList = [
  {
    name: "Provider",
    code: "PR",
  },
  {
    name: "Coder",
    code: "CO",
  },
  {
    name: "Facility",
    code: "FA",
  },
];

export const Finding_Disply_Order = [
  { value: 2, displayAlias: "Disagree First" },
  { value: 1, displayAlias: "Agree First" },
  { value: 0, displayAlias: "Field Order" },
];
export const Finding_Disply_Preference = [
  { value: 0, displayAlias: "Show All Cases" },
  { value: 1, displayAlias: "Hide Agree Cases" },
  { value: 2, displayAlias: "Hide All Agree Findings" },
  { value: 3, displayAlias: "Hide Agree Findings Except Line Item" },
];
export const Case_Disply_Order = [
  { value: 1, displayAlias: "Disagree Cases First" },
  { value: 0, displayAlias: "Agree Cases First" },
  { value: 2, displayAlias: "Audit Case Order" },
];
export const Case_Disply_Preference = [
  { value: 1, displayAlias: "Hide Agree All Cases" },
  { value: 0, displayAlias: "Show All Cases" },
];
export const exportFormats = [
  { value: "pdf", displayAlias: "PDF" },
  { value: "docx", displayAlias: "Word (.docx)" },
];

export const displayScoringMethods = [
  {
    name: "Average Case Weight",
    value: 5,
  },
  {
    name: "Average Line Weight",
    value: 14,
  },
  {
    name: "Case Accuracy",
    value: 6,
  },
  {
    name: "CPT Accuracy",
    value: 10,
  },
  {
    name: "E&M Accuracy",
    value: 12,
  },
  {
    name: "Field Accuracy",
    value: 8,
  },
  {
    name: "Improper Payment Rate (IPR)",
    value: 4,
  },
  {
    name: "Total Case Error Weight",
    value: 2,
  },
  {
    name: "Total Cases",
    value: 1,
  },
  {
    name: "Total Line Error Weight",
    value: 3,
  },
  {
    name: "Weighted Case Accuracy",
    value: 7,
  },
  {
    name: "Weighted CPT Accuracy",
    value: 11,
  },
  {
    name: "Weighted E&M Accuracy",
    value: 13,
  },
  {
    name: "Weighted Field Accuracy",
    value: 9,
  },
  {
    name: "Weighted Line Accuracy",
    value: 15,
  },
];

export const primaryScoringMethod = [
  { text: "Average Case Weight", value: 11 },
  { text: "Average Line Weight", value: 12 },
  { text: "Case Accuracy", value: 1 },
  { text: "CPT Accuracy", value: 5 },
  { text: "E&M Accuracy", value: 7 },
  { text: "Field Accuracy", value: 4 },
  { text: "Improper Payment Rate (IPR)", value: 10 },
  { text: "None", value: 0 },
  { text: "Weighted Case Accuracy", value: 2 },
  { text: "Weighted CPT Accuracy", value: 6 },
  { text: "Weighted E&M Accuracy", value: 8 },
  { text: "Weighted Field Accuracy", value: 9 },
  { text: "Weighted Line Accuracy", value: 3 },
];

export const groupByList = [
  { value: 0, text: "None" },
  { value: 1, text: "Rendering/Attending Provider" },
  { value: 2, text: "Coder" },
  { value: 3, text: "Facility" },
  { value: 4, text: "Rendering Provider Group" },
  { value: 5, text: "Coder Group" },
  { value: 6, text: "Auditor" },
  { value: 7, text: "Organized Entity" },
];

export const templateValidationGroup = "templateValidationGroup";

export const reportTemplateListUrl =
  "/admin/auditreportconfiguration?isShowList=true";

export const showEntitySummary = [
  { value: 0, displayAlias: "First" },
  { value: 1, displayAlias: "Last" },
];
